exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: block;\n  text-align: center;\n  position: relative;\n  height: 70px; }\n  :host .ui-widget.ui-widget-content {\n    top: 10px; }\n  :host .form-control {\n    position: absolute;\n    width: calc(50% - 6px);\n    padding: 6px 10px;\n    display: inline-block; }\n    :host .form-control[readonly] {\n      background-color: white; }\n      :host .form-control[readonly]:focus {\n        border-color: #DFE1E6;\n        box-shadow: none; }\n    :host .form-control.left {\n      left: 0; }\n    :host .form-control.right {\n      right: 0; }\n  :host .dash {\n    position: relative;\n    top: 10px;\n    left: 0.5px; }\n\ninput {\n  font-size: 12px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/slider-range/slider-range.component.scss
// module id = 953
// module chunks = 22